import styled from 'styled-components';

import { minWidth } from '../../../styles/mixins';
import { SCREEN_PADDING } from '../util';

export const ScreenContainer = styled.div`
  padding: 10px ${SCREEN_PADDING}px ${SCREEN_PADDING}px;
  ${minWidth.md`
    padding: 0;
  `};
`;
